module.exports = __webpack_public_path__ + "static/archive/GeoLite2-Country-CSV.681b4c6.zip";


//////////////////
// WEBPACK FOOTER
// ./src/assets/archive/GeoLite2-Country-CSV.zip
// module id = IVuZ
// module chunks = 1